//prod
const ApiHost = "https://co.zeto.bialystok.pl/api";
//dev
// const ApiHost = "http://localhost:5000";

export {ApiHost}